import { useMutation, useQueryClient } from '@common-fe/common-fe';
import { toNumber } from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface Props {
  teamId?: string;
  membersIds?: string[];
}

const useAssignProcessorsToTeamQuery = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation(
    (props: Props) =>
      api.put(API_URL.CLAIMS_TEAMS_CONTACTS_BY_CLAIMS_TEAM_ID(props.teamId || ''), {
        contacts_ids: [...new Set(props.membersIds?.map((item) => toNumber(item)) || [])],
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [API_URL.CLAIMS_TEAMS],
        });
        if (onSuccess) {
          onSuccess();
        }
      },
    }
  );

  return mutateAsync;
};

export default useAssignProcessorsToTeamQuery;
